export function normalizeNif(input: string | null | undefined): string {
  return (input ?? '').replace(/[\s\-\.\/]/g, '').toUpperCase();
}
